/**
 * Allow elements to collapse at small viewports while remaining open at large viewports
*/

import EventBus from './../event-bus.js'
import jQuery from 'jquery'

class ResponsiveCollapse {
    
    /**
     * Construct component
     * @param elements
    */
    constructor(elements) {
        
        /**
         * Collapse inputs
         * @type object
        */
        this.elements = elements
        
        this.bindEvents()
        this.handleResize()
        
    }
    
    /**
     * Handle screen resize
    */
    handleResize() {
        
        let
            collapse,
            toggle

        this.elements.each((i, element) => {
            
            collapse = jQuery(element)
            toggle = this.getToggle(collapse)
            
            if (window.matchMedia('(max-width: ' + parseInt(collapse.data('collapse-width')) + 'px)').matches) {
                if (!collapse.hasClass('opened')) {
                    collapse.stop().hide()
                }
            }
            else {
                collapse.stop().show()
            }
            
        })
        
    }
    
    /**
     * Handle toggler click
     * @param event
    */
    handleToggle(event) {
        
        event.preventDefault()
        
        let
            clicked = jQuery(event.target),
            target = clicked.attr('href'),
            element = jQuery(target),
            toggle = this.getToggle(element)
        
        element.stop().slideToggle().toggleClass('opened')
        element.hasClass('opened') ? toggle.addClass('opened') : toggle.removeClass('opened')
        
    }
    
    /**
     * Get element's toggler
     * @param element
    */
    getToggle(element) {
        return jQuery(element.data('toggled-by'))
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Window resize
        jQuery(window).resize(this.handleResize.bind(this))
        
        //Toggle click listener
        jQuery(document).on('click', '.collapse-responsive-toggle', this.handleToggle.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    let elements = jQuery('.collapse-responsive')
    
    if (elements.length > 0) {
        new ResponsiveCollapse(elements)
    }
    
})

export default ResponsiveCollapse